import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Side} from "../../_modules/x-components/x-models/x-enums/side";
import {
  CrossCheckDisplayComponent
} from "../../_modules/x-components/cross-check-display/cross-check-display.component";

@Component({
  selector: 'app-password-check',
  templateUrl: './password-check.component.html',
  imports: [
    CrossCheckDisplayComponent
  ],
  styleUrl: './password-check.component.scss'
})
export class PasswordCheckComponent implements OnChanges {
  @Input() password!: string;
  @Input() confirmation!: string;
  @Input() darkMode: boolean = false;
  pattern = new RegExp('^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,32}$');
  upper = new RegExp('(?=.*[A-Z])');
  lower = new RegExp('(?=.*[a-z])');
  special = new RegExp('(?=.*[!@#$&*])');
  numbers = new RegExp('(?=.*[0-9])');
  @Input() isValid: boolean = false;
  @Output() isValidChange = new EventEmitter<boolean>();
  protected readonly Side = Side;

  get hasUpperRequirement(): boolean {
    return this.upper.test(this.password);
  }

  get hasLowerRequirement(): boolean {
    return this.lower.test(this.password);
  }

  get hasSpecialRequirement(): boolean {
    return this.special.test(this.password);
  }

  get hasNumbersRequirement(): boolean {
    return this.numbers.test(this.password);
  }

  get hasLengthRequirement(): boolean {
    return this.password.length >= 8 && this.password.length <= 32;
  }

  get hasAllRequirements(): boolean {
    return this.pattern.test(this.password);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.password || changes.confirmation) {
      this.validate();
    }
  }

  private validate() {
    let valid = this.password == this.confirmation && this.hasAllRequirements;
    this.isValidChange.emit(valid);
  }
}
